import { Button, styled, Table, TableContainer, TableHead, TableRow, Theme } from '@material-ui/core';

export const MainContainer = styled('div')({
  minHeight: 600,
});

export const CustomTableContainer = styled(TableContainer)({
  marginTop: 20,
});

export const CustomTable = styled(Table)({
  background: '#0b0f14',
  '& .MuiTableCell-root': {
    borderBottom: 0,
  },
});

export const CustomTableHead = styled(TableHead)({
  '& th': {
    padding: '12px 30px 12px 30px',
  },
});

export const CustomTableRow = styled(TableRow)<Theme, { $status: string }>(({ $status }) => ({
  borderTop: '1px solid #313a46',
  '&:last-child': {
    borderBottom: '1px solid #313a46',
  },
  '& td': {
    padding: '11px 30px 12px 30px',
    background: $status === 'Failed' ? '#0d1520' : 'none',

    '&:nth-of-type(4) p': {
      color: $status === 'Failed' ? '#fb3f3f' : '#6fce37',
    },
  },
}));

export const CustomButton = styled(Button)({
  background: '#0b0f14',
  borderRadius: 5,
  border: '1px solid #3e8bff',
  fontSize: 14,
  padding: '5px 26px',
  height: 26,
});
